const userDashboardDictIT = {
  dashboard: "Dashboard",
  userDashboard: "Dashboard utente",
  wallet: "Portafoglio",
  transfer: "Trasferire",
  transferRequests: "Richieste di trasferimento",
  productServices: "Prodotti e servizi",
  maxBalanceReached: "Hai raggiunto il tuo saldo massimo.",
  new: "Nuovo",
  dropshipping: "Dropshipping",
  list: "Elenco",
  sales: "Vendite",
  purchases: "Acquisti",
  network: "Circolo Economico",
  directs: "Il tuo Circolo Economico",
  all: "Tutto",
  coupons: "Buono",
  attributes: "Attributi",
  withdraw: "Ritirare",
  yourStore: "Il tuo Negozio",
  favorites: "Preferiti",
  isService: "Questa sottocategoria è un servizio?",
  importProducts: "Importare Prodotti",
  pageNotFound: "Pagina non trovata",
  popupHeader1: "Fra",
  popupHeader2: "giorni scade il tuo abbonamento",
  subscriptionExpirationDate: "Data di scadenza dell'abbonamento",
  wantToRenewSubscription: "Vuoi rinnovare la tua iscrizione?",
  subscription: "Abbonamento",
  renewSubscription: "Rinnova l'abbonamento",
  payWithPaypal: "Paga con Paypal",
  walletBalancerRenew: "Saldo del portafoglio",
  paymentMethods: "Metodi di pagamento",
  errorRenewingSubscription:
    "Si è verificato un errore durante il rinnovo dell'abbonamento, riprova",
  youWantRenewWalletBalance: "Vuoi rinnovare con il saldo del portafoglio?",
  subscriptionRenewed: "Abbonamento rinnovato con successo!",
  yourSubcriptionExpired: "La tua iscrizione è scaduta",
  wantToRenewyourSubscription: "Vuoi rinnovarlo?",
  unfavorite: "Non preferito",
  waitLabel:
    "Aspetta che la tua etichetta venga generata. Premi semplicemente il pulsante sottostante quando il tuo ordine viene ritirato dal corriere.",
  freeRenewalsRemaining: "Rinnovi gratuiti rimanenti",
  BOZZA: "In cerca di approvazione",
  INSPEDIZIONE: "In transito",
  RITIRORICHIESTO: "Ritiro richiesto",
  CONSEGNATA: "Consegnato",
  errorDownloadLabel: "Si è verificato un errore durante la creazione dell'etichetta",
  nextAction: "Prossimo",
  closeAction: "Chiudi",
  backAction: "Indietro",
  welcomeToExtraconomy: "Benvenuto in Extraconomy",
  dashboardWelcomeMessage: "Benvenuto a ",
  ifYouWantToSellOnExtraconomy:
    "Se desideri vendere su extraconomy, segui i passaggi per imparare come creare il tuo negozio e i tuoi prodotti",
  registerYourAddress: "Registra il tuo indirizzo",
  initiallyYouNeedToRegisterYourAddress:
    "Inizialmente devi registrare il tuo indirizzo in modo che possiamo utilizzarlo per le consegne",
  fillInYourContactPhoneNumber: "Inserisci il tuo numero di telefono di contatto",
  fillInYourContactNumber:
    "Inserisci il tuo numero di telefono di contatto in modo che possiamo contattarti se necessario",
  fillInTheDetailsAboutTheShippingService: "Compila i dettagli sul servizio di spedizione",
  saveTheModifiedInformation: "Salva le informazioni modificate",
  afterFillingInAllTheInformation:
    "Dopo aver inserito tutte le informazioni, fare clic su Salva per salvare le informazioni",
  onThisPageYouWillConfigure: "In questa pagina configurerai i dettagli del tuo negozio",
  finallyOnThisPageYouWillRegisterYourProducts:
    "Infine, in questa pagina registrerai i tuoi prodotti",
  publicKey: "chiave pubblica",
  privateKey: "chiave privata",
  accessWallet: "Accedi al portafoglio",
  disconnectWallet: "Disconnetti Portafoglio",
  notifications: "Notifiche",
  noNotifications: "Nessuna notifica",
  StoresMap: "Mappa dei negozi",
  map: "Mappa",
  payments: "Pagamenti",
  payWithQrCode: "Paga con codice QR",
  payWithQrCodeDescription: "Punta la tua telecamera sul QR Code di pagamento.",
  createChargeWithQrCode: "Creazione di una fattura",
  createChargeWithQrCodeDescription: "Crea una fattura tramite QR Code",
  paymentTransaction: "Vuoi effettuare il pagamento per questa transazione?",
  pay: "Paga",
  transactionValue2: "Valore della transazione",
  banners: "Banner",
  amountToBeReceived: "Importo da ricevere",
  discountPercentual: "Percentuale di sconto",
  discountAbsolut: "Sconto assoluto",
  none: "Nessuno",
  percentual: "Percentuale",
  minimalOrderValueToActivateSetting: "Valore minimo dell'ordine per attivare l'impostazione",
  successSaveFreightRule: "Regola di spedizione salvata con successo",
  feightRules: "Regole di spedizione",
  setShippingRulesForYourStore: "Imposta le regole di spedizione per il tuo negozio.",
  newFringeBenefit: "Nuovo Flexible benefit",
  newProduct: "Nuevo Prodotto",
  listProducts: "Elenco Prodotti",
  listFringeBenefits: "Elenco Flexible Benefits",
  video: "Video",
  dragVideoFile: "Trascina il file video qui",
  videoUploadedSuccessfully: "Video caricato con successo",
  videoNotSupported: "Il tuo browser non supporta la riproduzione video",
  uploadVideoMaxSize20MB: "Carica un video fino a 20 MB per il tuo negozio",
  videoSizeExceeds20MB: "La dimensione del video supera i 20 MB",
  balanceAvailableForWithdrawal: "Saldo disponibile per il prelievo:",
  centralFinanceira: "Centro Finanziario",
  financialHubSubtitle: "Segui e gestisci le operazioni del tuo portafoglio Extraconomy.",
  patrimonyConsolidated: "Patrimonio consolidato",
  last30Days: "negli ultimi 30 giorni",
  walletEuro: "PORTAFOGLIO",
  withdrawable: "PRELIEVO",
  availableForWithdrawal: "Disponibile per il prelievo",
  withdrawAction: "Preleva",
  statement: "Estratto",
  useInStore: "Usa in negozio",
  extracredit: "Extracredit",
  consumption: "CONSUMO",
  purchasingPower: "potere d'acquisto",
  quickOperations: "Operazioni Rapide",
  transferECR: "Trasferisci ECR",
  financial: "Finanziario",
  overview: "Panoramica",
  transactions: "Transazioni",
  lifetimeWalletId: "ID",
  lifetimeWalletEntry: "Entrata",
  lifetimeWalletOutcome: "Uscita",
  bankAccounts: "Conti bancari",
  balanceSummary: "Riepilogo saldo",
  totalAvailable: "Totale disponibile",
  credit: "Credito",
  debit: "Debito",
  originOfFunds: "Origine delle risorse finanziarie",
  transactionsCarriedOut: "Transazioni effettuate",
  withdrawals: "Prelievi",
  requestWithdrawal: "Richiedi prelievo",
  dailyIncome: "Reddito giornaliero",
  noBankAccountWarning:
    "Nessun conto bancario registrato. Per richiedere prelievi, registra un conto.",
  bankAccountSettingsLink: "Impostazioni conti bancari",
  requestWithdrawalButton: "Richiedi prelievo",
  history: "Cronologia",
  availableBalance: "Saldo disponibile",
  howToUseCredits: "Come usare i tuoi crediti",
  creditMovement: "Movimentazione crediti",
  comingSoon: "In arrivo",
  invest: "Investire",
  swap: "Swap",
  bankAccountFormTitle: "Registrazione conto bancario",
  bankAccountFormTitleEdit: "Modifica conto bancario",
  bankAccountFormSubtitle: "Inserisci i dati del tuo conto.",
  identification: "Identificazione",
  mainAccount: "Conto principale",
  mainAccountHelp: "Spunta per impostare come conto principale.",
  bankDetails: "Dati bancari",
  accountType: "Tipo di conto",
  email: "Email",
  bankAccountRegister: "Registra",
  registeringAccount: "Registrazione del conto in corso. Attendere.",
  invalidIban: "IBAN non valido. Verificare il numero inserito.",
  accountRegisteredSuccess: "Conto registrato con successo.",
  accountUpdatedSuccess: "Conto aggiornato con successo.",
  accountDeletedSuccess: "Conto eliminato con successo.",
  addAccount: "Registra conto",
  configure: "Configura",
  myAccounts: "I miei conti",
  noAccountsMessage:
    "Non hai ancora conti bancari registrati. Registra un nuovo conto per effettuare trasferimenti.",
  transferTo: "Trasferisci a",
  selectAccount: "Seleziona un conto",
  processingWithdrawal: "Prelievo in corso...",
  cancel: "Annulla",
  save: "Salva",
  principal: "Principale",
  delete: "Elimina",
  confirmDeleteAccount: "Sei sicuro di voler eliminare questo conto?",
  attention: "Attenzione",
  yes: "Sì",
  no: "No",
  confirmWithdrawal: "Conferma prelievo",
  searchByTransaction: "Cerca per transazione",
  filter: "Filtra",
  transaction: "Transazione",
  operationType: "Tipo di operazione",
  registrationDate: "Data di registrazione",
  noOperationsRecords: "Ancora nessun record di operazioni.",
  saleInStore: "Vendita prodotto in negozio",
  purchaseInStore: "Acquisto prodotto in negozio",
  register: "Registrati",
  paymentMethodExtracredit: "Extracredit",
  paymentMethodWallet: "Saldo del portafoglio",
  paymentMethodPayPal: "PayPal",
  paymentMethodBankTransfer: "Bonifico bancario",
  paymentMethodMultiple: "Multipli",
  pendingReceipts: "Ricevute in sospeso",
  pendingReceiptsSent: "ha inviato",
  pendingReceiptsHint: "Questi valori verranno accreditati solo dopo l'accettazione.",
  approve: "Approva",
  recipientSelection: "Selezione del destinatario",
  recipientSelectionHint: "Seleziona chi riceverà il tuo trasferimento.",
  chooseRecipient: "Scegli il destinatario",
  searchRecipient: "Cerca destinatario...",
  userNotFound: "Questo utente non è stato trovato. Verifica i dati e riprova.",
  recipientDetails: "Dettagli del destinatario",
  changeRecipient: "Cambia destinatario",
  values: "Valori",
  valuesHint: "Inserisci quanto desideri trasferire a {name}.",
  available: "Disponibile",
  enterAmount: "Inserisci l'importo",
  platformFee: "Commissione della piattaforma",
  transferSummary: "Riepilogo trasferimento",
  transferSummaryHint: "Rivedi e conferma prima di finalizzare.",
  sendTo: "Invia a",
  recipient: "Destinatario",
  transferCompleted: "Trasferimento completato",
  goToStatement: "Vai all'estratto",
  powerOfUse: "Potere d'uso",
  powerOfUseDescription: "Paga fino al {percent}% dei tuoi acquisti con il saldo Extracredit.",
  powerOfUseLabel: "Puoi usare fino al {percent}% del tuo saldo ECR",
  powerOfUseManagerRule: "Per ogni referral pagato (non voucher) sblocchi 2%.",
  powerOfUseOtherRule: "Per ogni referral pagato sblocchi 1%.",
  unlocked: "sbloccato",
  goal: "Obiettivo",
  unlockMore: "Sblocca +",
  powerOfUseManagerUnlock: "Invita nuovi Partner (pagati, non voucher) per aumentare il limite.",
  powerOfUseOtherUnlock: "Invita nuovi Partner pagati per aumentare il limite.",
  opportunitiesToUse: "Opportunità con Extracrediti",
  accessStore: "Accedi al negozio",
  completeStatement: "Estratto completo",
  useCreditPercent: "Usa {percent}% Credito",
  credits: "Crediti",
  totalValue: "Valore totale",
  transferExtracredit: "Trasferisci Extracredit",
  transferExtracreditSubtitle:
    "Trasferisci Extracrediti ad altri utenti nell'ecosistema Extraconomy.",
  transferConfirmDisclaimerBefore: "Cliccando su ",
  sendCredits: "Invia crediti",
  transferConfirmDisclaimerMiddle: ", concedo a ",
  companyExtraconomy: "Extraconomy",
  transferConfirmDisclaimerAfter: " il permesso di procedere con la transazione dettagliata.",
  securityValidationTitle: "Validazione di sicurezza",
  securityValidationEmailSent:
    "Per la tua sicurezza, abbiamo inviato un codice di {length} caratteri a {email}",
  securityValidationConfirmTransfer:
    "Inserisci il codice per confermare il trasferimento di {amount} a {recipient}",
  securityValidationConfirmWithdrawal:
    "Inserisci il codice per confermare il prelievo di {amount} a {recipient}",
  securityValidationCodeExpires: "il codice scade tra {time}",
  securityValidationResend: "Reinvia codice",
  securityValidationResendIn: "Reinvia codice (in 5min)",
  securityValidationValidate: "Convalida codice",
  rejectNotAvailable: "Rifiutare non è disponibile.",
  search: "Cerca",
  toAgreeAndReceiveInsertCode:
    "Per accettare e ricevere, inserisci il codice inviato alla tua email:",
  confirmYourAction: "Conferma la tua azione",
  seeDetails: "Vedi dettagli",
  whiteLabel: "White Label",
  whiteLabelSettingsTitle: "Impostazioni aspetto",
  whiteLabelSettingsSubtitle: "Personalizza le impostazioni di aspetto della tua dashboard.",
  whiteLabelSaveChanges: "Salva modifiche",
  whiteLabelAssets: "Risorse",
  whiteLabelLogo: "Logo",
  whiteLabelFavicon: "Favicon",
  whiteLabelChooseFile: "Scegli file",
  whiteLabelClickToUpload: "Clicca per caricare",
  whiteLabelOrDragDrop: "o trascina e rilascia",
  whiteLabelFileFormatsLogo: "SVG, PNG, JPG o GIF (max. 400×400px)",
  whiteLabelFileFormatsFavicon: "SVG, PNG, JPG o GIF (max. 64×64px)",
  whiteLabelBrandColors: "Colori del brand",
  whiteLabelPrimaryColor: "Colore principale",
  whiteLabelSecondaryColor: "Colore di supporto",
  whiteLabelBackgroundColor: "Sfondo della piattaforma",
  whiteLabelTextColor: "Colore dei testi",
  whiteLabelTypography: "Tipografia",
  whiteLabelFont: "Font",
  whiteLabelSelectFont: "Seleziona il font",
  whiteLabelImageUploaded: "Immagine caricata con successo",
  whiteLabelThemeCreated: "Tema creato con successo",
  whiteLabelThemeUpdated: "Tema aggiornato con successo",
  whiteLabelChangesReset: "Modifiche ripristinate ai valori predefiniti",
  whiteLabelDefaultSettings: "Impostazioni predefinite",
  whiteLabelCustomNetworkDefault: "Rete personalizzata",
  whiteLabelPrimaryColorHelp:
    "Rappresenta l'identità del tuo brand. Verrà utilizzato per i pulsanti di azione, i link attivi e gli elementi di maggiore importanza.",
  whiteLabelSecondaryColorHelp:
    "Un colore secondario per creare contrasto. Apparirà in badge, icone di sfondo e dettagli visivi secondari.",
  whiteLabelBackgroundColorHelp:
    "Il colore predominante dietro i contenuti. Consigliamo toni chiari (come bianco o grigio chiaro) per facilitare la lettura.",
  whiteLabelTextColorHelp:
    "Definisce il colore di titoli e paragrafi. Scegli un tono scuro che contrasti bene con lo sfondo della piattaforma.",
  whiteLabelFontHelp:
    "La famiglia tipografica che darà voce alla tua piattaforma. Scegli un font leggibile e in linea con la tua immagine aziendale.",
  whiteLabelLogoPreview: "Anteprima del logo",
  whiteLabelFaviconPreview: "Anteprima del favicon",
  myCards: "Le mie carte",
  myCardsSubtitle: "Visualizza e gestisci le tue carte virtuali.",
  myCardsEmpty: "Nessuna carta disponibile.",
  myCardsClickToFlip: "Clicca sulla carta per girarla",
  myCardActive: "Attiva",
  myCardInactive: "Inattiva",
  orderSingular: "ordine",
  orderPlural: "ordini",
  awaitingProcessing: "In attesa di elaborazione",
  noPending: "Nessuna in sospeso",
  managerDashboardErrorLoad: "Errore nel caricamento dei dati della dashboard",
  managerStoreStatusPending: "In sospeso",
  managerNetworkLevelSenior: "Senior",
  managerWalletChangeVsPrevious: "+2% vs mese precedente",
  managerBalanceSales: "di vendite",
  managerTrackStoreHere: "Segui il tuo negozio qui.",
  managerBilling: "FATTURAZIONE",
  managerInProcessing: "in elaborazione",
  managerLiveStore: "NEGOZIO IN DIRETTA",
  managerNetworkEarnings: "GUADAGNI DI RETE",
  managerNetworkLevelLabel: "Livello di rete",
  managerTotalEarnings: "Guadagni totali",
  managerB2bPurchasingPower: "Potere d'acquisto B2B",
  managerBonusAds: "Bonus ADS",
  managerAdsForExternalAds: "ads per annunci esterni",
  managerFooterCompanyName: "EXTRACONOMY GLOBAL srl",
  managerFooterAddress: "Via Nomentana, 1018 - 00137 Roma (IT)",
  managerFooterTaxInfo: "P. Iva e C.F. 16948681008",
  managerFooterRea: "REA 1686351",
  economicCircle: "Cerchio economico",
  economicCircleSubtitle: "Segui il tuo cerchio economico e l'espansione.",
  invite: "Invita",
  inviteSubtitle: "Invita membri ed espandi la tua rete di influenza.",
  currentStatus: "Stato attuale",
  members: "Membri",
  networkPower: "Potere di rete",
  activeInfluence: "Influenza attiva",
  networkEarnings: "Guadagni di rete",
  thisMonth: "questo mese",
  totalAccumulatedLifetime: "Totale accumulato (Lifetime)",
  directCommission: "Commissione diretta",
  networkCommission: "Commissione di rete",
  networkHighlightsTop5: "In evidenza della rete (Top 5)",
  recentMembers: "Membri recenti",
  viewAll: "Vedi tutti",
  transactionHistory: "Cronologia transazioni",
  noRecentMembers: "Nessun membro recente.",
  origin: "Origine",
  type: "Tipo",
  date: "Data",
  value: "Valore",
  paid: "Pagato",
  goalForGold: "Obiettivo per GOLD",
  copied: "Copiato",
  copiedToClipboard: "Copiato negli appunti",
  qrcodereferralLinks: "QR Code dei link di referral",
  referralLinksExplanation: "Accedi per generare link di referral.",
  share: "Condividi",
  directMembers: "Membri diretti",
  indirectMembers: "Membri indiretti",
  totalReceived: "Totale ricevuto",
  withdrawalsMade: "Prelievi effettuati",
  membersAndTransactions: "Membri e transazioni",
  membersAndTransactionsSubtitle: "Membri e transazioni del tuo cerchio.",
  searchByMember: "Cerca per membro",
  indirects: "Indiretti",
  noMembers: "Nessun membro.",
  name: "Nome",
  actions: "Azioni",
  completed: "Completato",
  pending: "In attesa",
  canceled: "Annullato",
  active: "Attivo",
  inactive: "Inattivo",
  activeDigitalAssets: "Attivi digitali",
  privacyPolicy: "Politica sulla privacy",
  managerMobileNavOpenMenu: "Apri menu",
  partnerB2bTitle: "Partner B2B",
  partnerB2bSubtitle: "Trova e connettiti con partner strategici nella tua regione.",
  partnerB2bSearchPlaceholder: "Cerca codici ATECO o aree di attività...",
  partnerB2bRadiusLabel: "Raggio",
  partnerB2bRadiusKm: "km",
  partnerB2bSearch: "Cerca",
  partnerB2bAddressWarningText:
    "È necessario configurare la tua posizione (codice postale e indirizzo) per usare la ricerca geolocalizzata.",
  partnerB2bConfigurePosition: "Configura posizione",
  partnerB2bEmptyState:
    "Non sono stati trovati risultati con i criteri attuali. Prova ad ampliare il raggio di ricerca o a rimuovere alcuni filtri.",
  partnerB2bSubnetOnly: "Questa pagina è disponibile solo per i membri di una subnet.",
  partnerB2bContact: "Contatto",
  partnerB2bActivities: "Attività / ATECO",
  partnerB2bContactPartner: "Contatta il partner",
  partnerB2bGetDirections: "Ottieni indicazioni",
  partnerB2bDistanceFromYou: "A {km} km da te",
  partnerB2bClosestPartners: "Partner più vicini",
  partnerB2bShowingResultsInRadius: "Mostrando {count} {countLabel} in un raggio di {radius} km",
  partnerB2bResult: "risultato",
  partnerB2bResults: "risultati",
  partnerB2bWaitingForSearch: "In attesa di una ricerca per elencare i partner.",
  partnerB2bNoPartnersFound: "Nessun partner trovato per i filtri attuali.",
  partnerB2bFromYou: "da te",
  partnerServicesTitle: "Servizi dei partner",
  partnerServicesTabBusiness: "Servizi per le imprese",
  partnerServicesTabIndividuals: "Servizi per i privati",
  partnerServicesActivateService: "Attivare servizio",
  partnerServicesAwaitingFeedback: "In attesa di riscontro",
  partnerServicesServiceActivated: "Servizio attivato con successo",
  partnerServicesServiceActivationFailed: "Impossibile attivare il servizio",
  partnerServicesMenuLabel: "Servizi dei partner",
  backToFedernet: "Torna in Associazione",
  performanceChartLabel: "Performance Commerciale",
  performanceChartTitle: "Performance commerciale",
  performanceChartErrorLoadingData: "Errore nel caricamento dei dati",
  performanceChartLoading: "Caricamento...",
  accessCommercialDashboard: "Accedi alla dashboard commerciale",
  recentOperations: "Ultime operazioni",
  recentOperationsJustNow: "Adesso",
  recentOperationsMoreItems: "(+{count})",
  recentOperationsCustomerEmptyState: "Non hai ancora effettuato operazioni di acquisto.",
  recentOperationsExploreStore: "Scopri il negozio Extraconomy",
  customerHomeExtracreditBalanceTitle: "Saldo Extracredit (ECR)",
  customerHomeExtracreditEquivalent: "Equivalente a ~ {value} nel circuito",
  customerHomePendingTransactionsTitle: "Transazioni in sospeso",
  customerHomePendingTransactionsSubtitle: "Visualizza i tuoi ordini",
  customerHomeQuickActionsTitle: "Funzioni rapide",
  customerHomeExploreStores: "Esplora negozi",
  customerHomeFutureTitle: "In arrivo: nuove funzionalità per i Customer.",
  customerHomeFutureSubtitle:
    "Stiamo preparando nuove risorse per ampliare le possibilità di acquisto e servizi nella tua dashboard.",
  customerHomeFutureImageAlt: "Sezione informativa customer",
  myPurchases: "Ordini",
  myPurchasesSubtitle: "Tieni traccia dei tuoi acquisti e dello stato di ogni ordine.",
  totalPurchases: "Totale ordini",
  lastPurchaseDate: "Ultima ordine",
  noPurchases: "Nessun ordine ancora",
  searchByIdOrSeller: "Cerca per ID o venditore",
  partnerStoresMenuLabel: "Negozi convenzionati",
  upgradePageNotAvailableTitle: "Aggiornamento non disponibile",
  upgradePageNotAvailableDescription:
    "Questo profilo non ha opzioni di aggiornamento piano disponibili in questo momento.",
  upgradePageHeadlineCustomer: "Sblocca il tuo potenziale di guadagno",
  upgradePageHeadlinePartner: "Scala il tuo business nell'e-commerce",
  upgradePageHeadlineSeller: "Domina il territorio con la geolocalizzazione",
  upgradePageHeadlineStore: "Inizia la tua crescita nell'e-commerce",
  upgradePageSubheadlineCustomer:
    "Diventa Partner o Manager per accedere al piano carriera e generare entrate concrete nel nostro ecosistema.",
  upgradePageSubheadlinePartner:
    "Attiva il piano StartSeller e porta il tuo negozio fisico online, superando ogni confine geografico.",
  upgradePageSubheadlineSeller:
    "Migra al profilo Manager per ricevere automaticamente i clienti della tua zona tramite la nostra App.",
  upgradePageSubheadlineStore:
    "Attiva il piano Start Seller per sbloccare vendite online e pubblicazione prodotti nel marketplace.",
  upgradePaymentTitle: "Completa l'aggiornamento",
  upgradeMostPopular: "più scelto",
  upgradePlanNamePartner: "PARTNER",
  upgradePlanNameSeller: "SELLER",
  upgradePlanNameManager: "MANAGER",
  upgradePlanNameStartSeller: "START SELLER",
  upgradePlanDescriptionPartner: "Per chi inizia a vendere online.",
  upgradePlanDescriptionSeller: "Per chi vuole incrementare le proprie vendite.",
  upgradePlanDescriptionManager: "Per chi vuole ampliare il proprio business.",
  upgradePlanDescriptionStartSeller: "Per chi vuole incrementare le proprie vendite.",
  upgradeFeatureStorefront: "Vetrina online",
  upgradeFeatureEconomicCircle: "Circolo economico",
  upgradeFeatureNoMonthlyFee: "Senza pagamenti mensili",
  upgradeFeaturePersonalEcommerce: "E-commerce personale",
  upgradeFeatureDropshipping: "Include il Dropshipping",
  upgradeFeatureOnlineStore: "Negozio online",
  upgradeFeatureGeolocationActive: "Geolocalizzazione attiva",
  upgradeFeatureAllIncluded: "Tutto incluso",
  upgradeStartSellerRenewal: "Rinnovo annuale: EUR 35,00",
  storeActivateStartSellerWarning:
    "Per pubblicare prodotti, attiva il piano Start Seller nell'upgrade dell'account.",
  storeActivateStartSellerCta: "Attiva Vendite Online Start Seller",
  productLimitReached:
    "Hai raggiunto il limite di {limit} annunci del tuo piano. Esegui l'upgrade del piano per aggiungere nuovi annunci.",
  storeProductsLimitWarning:
    "Hai raggiunto il limite di {limit} annunci del tuo piano. Fai l'upgrade per continuare ad aggiungere prodotti e servizi.",
  paymentsPysicalStore: "Ricevi pagamenti come Negozio Convenzionato",
  payPhysicalStore: "Paga negozio fisico",
  physicalStoreProofSubmitted: "Comprovante inviato, in attesa di convalida.",
  securityCodeLabel: "Codice di sicurezza (inviato alla tua e-mail):",
  securityCodeSend: "Invia codice",
  securityCodeResend: "Reinvia codice",
  securityCodeHint: "Clicca su \"Invia codice\" e inserisci il codice ricevuto via e-mail. Ogni nuovo invio annulla il codice precedente.",
  securityCodeSent: "Codice inviato! Controlla la tua e-mail.",
  securityCodeCantBeEmpty: "Inserisci il codice di sicurezza inviato via e-mail.",
  securityCodeIsWrong: "Codice di sicurezza non valido o scaduto.",
};

export default userDashboardDictIT;
